export default "__VITE_ASSET__fuPYKJ_O__"